const CloseButton = ({onClose}) => {
    return(
    <button className="close-button" onClick={onClose}>
        &times;
        {/* <img src="btn_web_close.png" width="75%"/> */}
    </button>
    );
}

export default CloseButton;